import { RekbotSettingsOpenHours } from "./rekbot-settings-open-hours.model";

export class RekbotSettings {
    public id: number|null;
    public rekbot_id: number|null;
    public product_update_date: string;
    public email: string;
    public receive_bottles: number;
    public receive_cans: number;
    public sound_mute: number;
    public sound_volume: number;

    public report_daily: number;
    public report_weekly: number;
    public report_monthly: number;

    public barcode_length: number;
    public barcode_prefix: string;
    public receipt_live_time: number;

    public discount_bottle: number;
    public discount_can: number;

    public print_template: string;

    public street: string;
    public city: string;
    public post_code: string;
    public country: string;
    public language: string;
    public currency: string;

    public alert_email: string;

    public contact_person?: string;
    public contact_company?: string;
    public contact_phone?: string;
    public contact_email?: string;

    public display?: string;
    public scanner?: string;
    public store_api_key?: string;

    public open_hours: Array<RekbotSettingsOpenHours>;
    public lat?: string;
    public lon?: string;
    public current_location?: string;

    constructor(
        id: number|null, 
        rekbot_id: number|null, 
        product_update_date: string, 
        email: string, 
        receive_bottles: number,
        receive_cans: number,
        sound_mute: number,
        sound_volume: number,

        report_daily: number,
        report_weekly: number,
        report_monthly: number,
    
        barcode_length: number,
        barcode_prefix: string,
        receipt_live_time: number,
    
        discount_bottle: number,
        discount_can: number,
    
        print_template: string,
    
        street: string,
        city: string,
        post_code: string,
        country: string,
        language: string,
        currency: string,
        alert_email: string,

        contact_person: string,
        contact_company: string,
        contact_phone: string,
        contact_email: string,

        display: string,
        scanner: string,

        store_api_key: string,

    
        open_hours: [],
        ) {
            
        this.id = id;
        this.rekbot_id = rekbot_id;
        this.product_update_date = product_update_date;
        this.email = email;
        this.receive_bottles = receive_bottles; 
        this.receive_cans = receive_cans; 
        this.sound_mute = sound_mute; 
        this.sound_volume = sound_volume; 

        this.report_daily = report_daily; 
        this.report_weekly = report_weekly; 
        this.report_monthly = report_monthly; 
        this.barcode_length = barcode_length; 
        this.barcode_prefix = barcode_prefix; 
        this.receipt_live_time = receipt_live_time; 
        this.discount_bottle = discount_bottle; 
        this.discount_can = discount_can; 
        this.print_template = print_template; 

        this.street = street; 
        this.city = city; 
        this.post_code = post_code; 
        this.country = country; 
        this.language = language; 
        this.currency = currency; 
        this.alert_email = alert_email; 

        this.contact_person = contact_person; 
        this.contact_company = contact_company; 
        this.contact_phone = contact_phone; 
        this.contact_email = contact_email; 

        this.display = display; 
        this.scanner = scanner; 

        this.store_api_key = store_api_key; 

        this.open_hours = open_hours; 
    }

    static empty() {
        return {
    id: null,
    rekbot_id: null,
    product_update_date: "",
    email: "",
    receive_bottles: 1,
    receive_cans: 1,
    sound_mute: 0,
    sound_volume: 100,
    report_daily: 0,
    report_weekly: 0,
    report_monthly: 0,
    barcode_length: 14,
    barcode_prefix: "82",
    receipt_live_time: 30,
    discount_bottle: 50,
    discount_can: 50,
    print_template: "",
    street: "",
    city: "",
    post_code: "",
    country: "",
    lat: "",
    lon: "",
    language: "PL",
    currency: "PLN",
    alert_email: "",

    contact_person: "",
    contact_company: "",
    contact_phone: "",
    contact_email: "",

    display: "",
    scanner: "",
    store_api_key: "",

    open_hours: [
      {
        "id": null,
        "rekbot_id": null,
        "day": 1,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 2,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 3,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 4,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 5,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 6,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      },
      {
        "id": null,
        "rekbot_id": null,
        "day": 7,
        "open": 0,
        "open_time": "00:00",
        "close_time": "00:00"
      }]
  };
    }
}